import tetra from "../assets/tetra textile.jpg";
import cambridge from "../assets/cambridge.png";
import edurate from "../assets/EduRate.png";
import zakovat from "../assets/zakovat.png";
import core from "../assets/core.png";
import teenvision from "../assets/teenvision.png";
import catloop from "../assets/mobileapps/catloop.png";
import catris from "../assets/mobileapps/catris.png";
import kardo from "../assets/mobileapps/kardo.png";
import mathrow from "../assets/mobileapps/mathrow.png";
import nerva from "../assets/mobileapps/nerva.png";
import pavo from "../assets/mobileapps/pavo.png";
import pulchi from "../assets/mobileapps/pulchi.png";
import shiftball from "../assets/mobileapps/shiftball.png";
import spinject from "../assets/mobileapps/spinject.jpg";
import sudokitten from "../assets/mobileapps/sudokitten.png";
import tictactoe from "../assets/mobileapps/tictactoe.png";
import uybek from "../assets/mobileapps/uybek.png";


import brilliant from "../assets/brilliant.jpg"
import kink from "../assets/kink.jpg"


export const webProjects = [
  {
    id: 1,
    title: "Tetra Textile",
    img: tetra,
    github: "https://github.com/Akbarshoh404/Tetra-Textile",
    demo: "https://tetra-textile.netlify.app/",
    description_en:
      "A modern textile industry website featuring a catalog of fabrics, company portfolio, and contact forms for business inquiries. Built with sleek animations and responsive design.",
    description_ru:
      "Современный сайт текстильной компании с каталогом тканей, портфолио и формами для деловых запросов. Разработан с плавными анимациями и адаптивным дизайном.",
    description_uz:
      "Zamonaviy to'qimachilik kompaniyasi sayti — mato katalogi, korporativ portfolio va biznes so'rovlari uchun formalar. Silliq animatsiyalar va moslashuvchan dizayn bilan qurilgan.",
  },
  {
    id: 2,
    title: "Cambridge",
    img: cambridge,
    github: "https://github.com/Akbarshoh404/Cambridge-Website",
    demo: "https://cambridge-lessons.netlify.app",
    description_en:
      "An educational platform for the Cambridge Learning Center, offering course details, student resources, and an interactive schedule for learners.",
    description_ru:
      "Образовательная платформа для Cambridge Learning Center: информация о курсах, ресурсы для студентов и интерактивное расписание.",
    description_uz:
      "Cambridge Learning Center uchun ta'lim platformasi — kurslar haqida ma'lumot, talabalar resurslari va interaktiv dars jadvali.",
  },
  {
    id: 3,
    title: "EduRate",
    img: edurate,
    github: "https://github.com/BFozilkhon/EduRate",
    demo: "https://www.edurate.uz/",
    description_en:
      "A detailed rating and feedback system for educational institutions, allowing students to rate teachers and courses to improve quality standards.",
    description_ru:
      "Система рейтинга и отзывов для образовательных учреждений: студенты оценивают преподавателей и курсы для повышения качества образования.",
    description_uz:
      "Ta'lim muassasalari uchun batafsil reyting va fikr-mulohaza tizimi — talabalar o'qituvchilar va kurslarni baholab, sifatni oshirishga yordam beradi.",
  },
  {
    id: 4,
    title: "Teen-Vision",
    img: teenvision,
    github: "https://github.com/Akbarshoh404/TeenVision.git",
    demo: "https://teen-vision.uz/",
    description_en:
      "A vibrant youth-focused platform designed to inspire and connect young talents, showcasing events, achievements, and opportunities for teenagers.",
    description_ru:
      "Яркая молодёжная платформа для вдохновения и объединения юных талантов — мероприятия, достижения и возможности для подростков.",
    description_uz:
      "Yosh iqtidorlarni ilhomlantirish va birlashtirish uchun mo'ljallangan yoshlarga yo'naltirilgan platforma — tadbirlar, yutuqlar va imkoniyatlar.",
  },
  {
    id: 5,
    title: "Zakovat",
    img: zakovat,
    github: "https://github.com/Akbarshoh404/Zakovat.git",
    demo: "https://ict-zakovat.netlify.app/",
    description_en:
      "An interactive quiz and intellectual game platform inspired by the famous Zakovat TV show, featuring multiple rounds, categories, and leaderboards.",
    description_ru:
      "Интерактивная платформа викторин и интеллектуальных игр, вдохновлённая телешоу «Закoват», с раундами, категориями и таблицей лидеров.",
    description_uz:
      "Mashhur \"Zakovat\" ko'rsatuvidan ilhom olgan interaktiv viktorina va intellektual o'yin platformasi — turlar, kategoriyalar va liderlar jadvali bilan.",
  },
  {
    id: 6,
    title: "Core Collection",
    img: core,
    github: "https://github.com/Akbarshoh404/Core-Collection.git",
    demo: "https://core-collection.netlify.app/",
    description_en:
      "A stylish e-commerce storefront for a fashion brand, featuring product listings, a shopping cart, and a sleek minimalist design for modern shoppers.",
    description_ru:
      "Стильный интернет-магазин для модного бренда с каталогом товаров, корзиной и минималистичным дизайном для современных покупателей.",
    description_uz:
      "Moda brendi uchun zamonaviy elektron do'kon — mahsulotlar katalogi, xarid savati va minimalist dizayn bilan.",
  },
  {
    id: 7,
    title: "Brilliant Tour",
    img: brilliant,
    github: "https://github.com/Akbarshoh404/Brilliant-tour-website.git",
    demo: "https://brilliant-tour-website.vercel.app/",
    description_en:
      "A modern travel agency website offering international and domestic tour packages, featuring destination browsing, detailed trip information, online booking, and a responsive user-friendly design.",
    description_ru:
      "Современный сайт туристического агентства с международными и внутренними турами. Включает каталог направлений, подробную информацию о поездках, онлайн-бронирование и адаптивный дизайн.",
    description_uz:
      "Xalqaro va O‘zbekiston bo‘ylab sayohat turlarini taklif qiluvchi zamonaviy turizm agentligi sayti. Unda yo‘nalishlar katalogi, sayohatlar haqida batafsil ma’lumot, onlayn bron qilish va barcha qurilmalarga mos dizayn mavjud.",
  },
  {
    id: 8,
    title: "Kink",
    img: kink,
    github: "https://github.com/Akbarshoh404/Kink.git",
    demo: "https://kinkmvp.netlify.app/",
    description_en:
      "A modern marketplace for local sneaker stores, offering designer footwear from brands like Nike, Adidas, Puma, and more. Features product browsing, detailed listings, and a clean, responsive shopping experience.",
    description_ru:
      "Современный маркетплейс для местных магазинов кроссовок с дизайнерской обувью от Nike, Adidas, Puma и других брендов. Включает каталог товаров, подробные карточки и удобный адаптивный интерфейс.",
    description_uz:
      "Mahalliy krossovka do‘konlari uchun zamonaviy marketplace. Nike, Adidas, Puma va boshqa mashhur brendlarning dizayner krossovkalarini taklif qiladi. Mahsulotlar katalogi, batafsil sahifalar va qulay, moslashuvchan dizaynga ega.",
  },
];

export const mobileProjects = [
  {
    id: 1,
    title: "Catloop",
    img: catloop,
    logoPath: "src/assets/mobileapps/catloop.png",
    github: "https://github.com/Akbarshoh404/CatLoop.git",
    playMarket:
      "https://play.google.com/store/apps/details?id=uz.angrykitten.catloopak&pcampaignid=web_share",
    description_en:
      "An addictive arcade game where players guide a cat through increasingly challenging levels with fast-paced gameplay and responsive controls.",
    description_ru:
      "Увлекательная аркадная игра, где игрок управляет котом, проходя всё более сложные уровни с динамичным геймплеем.",
    description_uz:
      "O'yinchi mushukni boshqarib, tobora qiyinlashib boruvchi bosqichlardan o'tadigan qiziqarli arkada o'yini.",
  },
  {
    id: 2,
    title: "Catris",
    img: catris,
    logoPath: "src/assets/mobileapps/catris.png",
    github: "https://github.com/Akbarshoh404/Catris.git",
    playMarket:
      "https://play.google.com/store/apps/details?id=uz.angrykitten.catris&pcampaignid=web_share",
    description_en:
      "A modern take on the classic Tetris experience featuring smooth animations, score tracking, and engaging puzzle gameplay.",
    description_ru:
      "Современная версия классического Тетриса с плавными анимациями, подсчётом очков и увлекательным игровым процессом.",
    description_uz:
      "Silliq animatsiyalar, ochkolar tizimi va qiziqarli boshqotirma elementlariga ega zamonaviy Tetris o'yini.",
  },
  {
    id: 3,
    title: "Kardo",
    img: kardo,
    logoPath: "src/assets/mobileapps/kardo.png",
    github: "",
    playMarket: "",
    description_en:
      "A memory training game designed to improve concentration and recall through fun card-matching challenges.",
    description_ru:
      "Игра для тренировки памяти, помогающая улучшить концентрацию и запоминание через карточные задания.",
    description_uz:
      "Kartalarni moslashtirish orqali xotira va diqqatni rivojlantiruvchi qiziqarli o'yin.",
  },
  {
    id: 4,
    title: "Mathrow",
    img: mathrow,
    logoPath: "src/assets/mobileapps/mathrow.png",
    github: "",
    playMarket:
      "https://play.google.com/store/apps/details?id=uz.angrykitten.mathrow&pcampaignid=web_share",
    description_en:
      "A unique mathematical puzzle game inspired by Sudoku, challenging players with logic-based number mechanics.",
    description_ru:
      "Уникальная математическая головоломка, вдохновлённая Судоку, с логическими числовыми задачами.",
    description_uz:
      "Sudokudan ilhomlangan, mantiqiy sonli topshiriqlarga asoslangan noyob matematik boshqotirma.",
  },
  {
    id: 5,
    title: "Nerva",
    img: nerva,
    logoPath: "src/assets/mobileapps/nerva.png",
    github: "https://github.com/Akbarshoh404/Nerva.git",
    playMarket:
      "https://play.google.com/store/apps/details?id=uz.angrykitten.nervakb&pcampaignid=web_share",
    description_en:
      "A human benchmark application that measures reaction time, memory, accuracy, and cognitive performance through interactive tests.",
    description_ru:
      "Приложение для оценки когнитивных способностей: реакции, памяти, точности и других навыков.",
    description_uz:
      "Interaktiv testlar orqali reaktsiya tezligi, xotira va kognitiv qobiliyatlarni o'lchovchi ilova.",
  },
  {
    id: 6,
    title: "Pavo",
    img: pavo,
    logoPath: "src/assets/mobileapps/pavo.png",
    github: "https://github.com/Akbarshoh404/Pavo.git",
    playMarket: "",
    description_en:
      "A pet marketplace platform where users can buy, sell, and discover pets with an intuitive browsing experience.",
    description_ru:
      "Маркетплейс домашних животных для покупки, продажи и поиска питомцев через удобный интерфейс.",
    description_uz:
      "Uy hayvonlarini sotib olish, sotish va topish uchun yaratilgan qulay marketplace platformasi.",
  },
  {
    id: 7,
    title: "Pulchi",
    img: pulchi,
    logoPath: "src/assets/mobileapps/pulchi.png",
    github: "https://github.com/Akbarshoh404/Budget-Tracker.git",
    playMarket:
      "https://play.google.com/store/apps/details?id=uz.angrykitten.pulchi&pcampaignid=web_share",
    description_en:
      "A personal finance and budget tracking application that helps users manage expenses, income, and savings effectively.",
    description_ru:
      "Приложение для учёта бюджета и финансов, помогающее контролировать расходы, доходы и накопления.",
    description_uz:
      "Xarajatlar, daromadlar va jamg'armalarni boshqarishga yordam beruvchi shaxsiy moliya ilovasi.",
  },
  {
    id: 8,
    title: "Shiftball",
    img: shiftball,
    logoPath: "src/assets/mobileapps/shiftball.png",
    github: "https://github.com/Akbarshoh404/ShiftBall.git",
    playMarket:
      "https://play.google.com/store/apps/details?id=uz.angrykitten.shiftballak&pcampaignid=web_share",
    description_en:
      "A fast-paced arcade game focused on timing, precision, and quick decision-making mechanics.",
    description_ru:
      "Динамичная аркадная игра, основанная на точности, реакции и быстром принятии решений.",
    description_uz:
      "Aniqlik, tezkor fikrlash va reaktsiyani talab qiluvchi dinamik arkada o'yini.",
  },
  {
    id: 9,
    title: "Spinject",
    img: spinject,
    logoPath: "src/assets/mobileapps/spinject.jpg",
    github: "https://github.com/Akbarshoh404/Spinject.git",
    playMarket:
      "https://play.google.com/store/apps/details?id=uz.angrykitten.spinjectak&pcampaignid=web_share",
    description_en:
      "An action-packed game featuring spinning mechanics, challenging levels, and engaging gameplay progression.",
    description_ru:
      "Захватывающая игра с механикой вращения, сложными уровнями и интересным развитием игрового процесса.",
    description_uz:
      "Aylanish mexanikasi va murakkab bosqichlarga ega qiziqarli o'yin.",
  },
  {
    id: 10,
    title: "SudoKitten",
    img: sudokitten,
    logoPath: "src/assets/mobileapps/sudokitten.png",
    github: "https://github.com/Akbarshoh404/AngryKittenSudoku.git",
    playMarket:
      "https://play.google.com/store/apps/details?id=uz.angrykitten.sudoku&pcampaignid=web_share",
    description_en:
      "A Sudoku puzzle game with multiple difficulty levels, clean design, and a relaxing user experience.",
    description_ru:
      "Игра Судоку с несколькими уровнями сложности, минималистичным дизайном и комфортным интерфейсом.",
    description_uz:
      "Bir nechta qiyinchilik darajalari va qulay interfeysga ega Sudoku boshqotirma ilovasi.",
  },
  {
    id: 11,
    title: "Tic Tac Toe",
    img: tictactoe,
    logoPath: "src/assets/mobileapps/tictactoe.png",
    github: "https://github.com/Akbarshoh404/Angry-Kitten-TicTacToe.git",
    playMarket:
      "https://play.google.com/store/apps/details?id=uz.angrykitten.tictactoe&pcampaignid=web_share",
    description_en:
      "A classic Tic Tac Toe game featuring a modern interface, smooth gameplay, and local multiplayer support.",
    description_ru:
      "Классические крестики-нолики с современным интерфейсом и поддержкой локального мультиплеера.",
    description_uz:
      "Zamonaviy interfeys va mahalliy multiplayer rejimiga ega klassik krestik-nollik o'yini.",
  },
  {
    id: 12,
    title: "Uybek",
    img: uybek,
    logoPath: "src/assets/mobileapps/uybek.png",
    github: "",
    playMarket:
      "https://play.google.com/store/apps/details?id=uz.angrykitten.uybekak&pcampaignid=web_share",
    description_en:
      "A real estate marketplace that allows users to buy, sell, and rent properties through a streamlined mobile experience.",
    description_ru:
      "Платформа недвижимости для покупки, продажи и аренды жилья через мобильное приложение.",
    description_uz:
      "Uylarni sotib olish, sotish va ijaraga berish uchun yaratilgan ko'chmas mulk marketplace ilovasi.",
  },
];
